import React from 'react';
import './Radio.scss';

const Radio = ({label, value, onChange, radioStyle, id, small, checked,disabled=false}) => {
    return (
        <p style={ radioStyle } key={id} className={small ? 'small' : 'normal-radio'}>
            <input type="radio" id={id} value={value} checked={checked} onChange={(e) => onChange(e.target.value)} disabled={disabled}/>
            <label htmlFor={id} style={ { color : disabled ? '#9f9f9f' : ''}}>{label}</label>
        </p>
    )
}

export default Radio;